export class RedshiftServerlessNamespaces {
    'namespaces';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "namespaces",
            "baseName": "namespaces",
            "type": "Array<RedshiftServerlessNamespace>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RedshiftServerlessNamespaces.attributeTypeMap;
    }
    constructor() {
    }
}
